import Masthead from "./components/Masthead";
import Hero from "./components/Hero";
import FlashFeed from "./components/FlashFeed";
import HotRanking from "./components/HotRanking";
import EventArchive from "./components/EventArchive";
import CollectionIndex from "./components/CollectionIndex";
import PersonRoundup from "./components/PersonRoundup";
import Editorial from "./components/Editorial";
import StatsBand from "./components/StatsBand";
import JoinCta from "./components/JoinCta";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Masthead />
      <main>
        <Hero />
        <FlashFeed />
        <HotRanking />
        <EventArchive />
        <CollectionIndex />
        <PersonRoundup />
        <Editorial />
        <StatsBand />
        <JoinCta />
      </main>
      <Footer />
    </div>
  );
}